<template lang="pug">
v-btn(small, text, color="secondary", @click="load()", :loading="loading") Date Time
</template>

<script>
export default {
  props: {
    mid: { type: String, required: true },
    hsn: { type: String, required: true },
  },
  data() {
    return { loading: false };
  },
  methods: {
    async load() {
      if (!this.mid) return;
      this.loading = true;
      const dateTime = new Date().toISOString();
      const params = { mid: this.mid, hsn: this.hsn, dateTime };
      try {
        await this.$api.cardpointe.bolt.dateTime(params);
        this.$toast.success("Time set");
      } catch (e) {
        this.$toast.error(e.response?.data || e.message);
      }
      this.loading = false;
    },
  },
};
</script>